import ViewContractModal from "./view-contract-modal.component";

export default ViewContractModal;
